import React from 'react';
import VersionHistorySection from '../VersionHistorySection';
import { useEpdVersionHistoryDataOrWhileLoadingThenNull } from '../utils/EpdVersionHistoryDataContext';
import SmartLabel from 'components/v2/labels/SmartLabel';
import DynamicGridPdf from '../../grids/lca-results/DynamicGridPdf';
import FixedGridPdf from '../../grids/lca-results/FixedGridPdf';
import { CpcrPerformanceInformationModel, CpcrPerformanceTableModel } from 'types/types';

const VersionHistoryTechnicalPerformanceSection: React.FC<{}> = () => {
  const data = useEpdVersionHistoryDataOrWhileLoadingThenNull();
  if (!data) {
    return null;
  }
  const cpcrSpecificData = data.cpcrSpecificData;

  const isThereAnythingToDisplay = cpcrSpecificData.tables.some((t) => isCpcrPerformanceTableFilledIn(cpcrSpecificData, t));

  if (!isThereAnythingToDisplay) {
    return null;
  }

  return (
    <VersionHistorySection title="Technical characteristics and performance">
      {cpcrSpecificData.tables.map((t) => {
        return (
          isCpcrPerformanceTableFilledIn(cpcrSpecificData, t) && (
            <React.Fragment key={t.tableCode}>
              {t.isFixed ? (
                <div>
                  <SmartLabel label={t.tableTitle} />
                  <FixedGridPdf
                    columns={cpcrSpecificData.columns.filter((x) => x.tableCode == t.tableCode)}
                    value={cpcrSpecificData.data.filter((x) => x.tableCode == t.tableCode) || []}
                  />
                </div>
              ) : (
                (cpcrSpecificData.data.filter((x) => x.tableCode == t.tableCode) || []).length > 0 && (
                  <div>
                    <SmartLabel label={t.tableTitle} />
                    <DynamicGridPdf
                      columns={cpcrSpecificData.columns.filter((x) => x.tableCode == t.tableCode)}
                      value={cpcrSpecificData.data.filter((x) => x.tableCode == t.tableCode) || []}
                    />
                  </div>
                )
              )}
            </React.Fragment>
          )
        );
      })}
    </VersionHistorySection>
  );
};

export const isCpcrPerformanceTableFilledIn = (
  cpcrSpecificData: CpcrPerformanceInformationModel,
  table: CpcrPerformanceTableModel
) => {
  const tableColumns = cpcrSpecificData.columns.filter((c) => c.tableCode === table.tableCode);
  const columnsFields = (table.isFixed ? tableColumns.slice(1) : tableColumns).map((col) => `a${col.ord}`);
  const filteredData = cpcrSpecificData.data.filter((row) => row.tableCode === table.tableCode);
  const isTableFilledIn = filteredData.some((row) => columnsFields.some((col) => row[col as keyof typeof row]));

  return isTableFilledIn;
};

export default VersionHistoryTechnicalPerformanceSection;
